/**
 * Rutas de Admin Suite.
 * Al agregar rutas nuevas, asegúrese de que el hosting/CDN las sirva al SPA.
 */

export const CUSTOMERS_PATH = '/admin/customers';
export const USERS_PATH = '/admin/users';
export const GROUPS_PATH = '/admin/business_groups';
export const ACCOUNT_SETTINGS_PATH = '/admin/account/settings';
export const GENERATE_GUIDE = '/admin/guide';
